import { Component } from "react";
import { AlertOctagon, RotateCw, LogOut } from "lucide-react";
import { clearToken } from "@/api/client";

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error("ErrorBoundary caught", error, info);
    }
    render() {
        if (!this.state.error) return this.props.children;
        const msg = this.state.error?.message || String(this.state.error);
        return (
            <div
                className="min-h-screen flex items-center justify-center bg-ux-bg-0 p-4"
                data-testid="error-boundary-fallback"
            >
                <div className="bg-ux-bg-1 border border-ux-border-1 rounded-lg p-6 max-w-lg w-full">
                    <div className="flex items-center gap-2 text-ux-text-1 mb-2">
                        <AlertOctagon className="w-5 h-5 text-ux-danger" />
                        <h1 className="text-[16px] font-semibold">Something went wrong</h1>
                    </div>
                    <p className="text-[13px] text-ux-text-2 mb-2">
                        The operator console hit an unexpected error and could not render this view.
                    </p>
                    <pre
                        className="text-[12px] font-mono whitespace-pre-wrap break-words bg-ux-bg-0 border border-ux-border-1 rounded-md p-3 max-h-60 overflow-auto text-ux-text-1"
                        data-testid="error-boundary-message"
                    >
                        {msg}
                    </pre>
                    <div className="mt-4 flex justify-end gap-2">
                        <button
                            type="button"
                            onClick={() => {
                                clearToken();
                                window.location.assign("/login");
                            }}
                            className="inline-flex items-center gap-1.5 text-[13px] px-3 h-9 rounded-md border border-ux-border-2 text-ux-text-2 hover:text-ux-text-1 hover:bg-ux-bg-2"
                            data-testid="error-boundary-signout"
                        >
                            <LogOut className="w-4 h-4" /> Sign out
                        </button>
                        <button
                            type="button"
                            onClick={() => window.location.reload()}
                            className="inline-flex items-center gap-1.5 text-[13px] px-3 h-9 rounded-md bg-ux-accent text-[#0B0F14] hover:brightness-110"
                            data-testid="error-boundary-reload"
                        >
                            <RotateCw className="w-4 h-4" /> Reload
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
